import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useMyHrUserRolesDataByContract } from "my-hr/hooks";
import { MyHRMyInfoPage } from "my-hr/pages/my-info-page";
import { useMyNewsEnabled } from "my-news/hooks";
import useMyNewsList from "my-news/hooks/use-list";
import MyNewsListPage from "my-news/pages/list-page";
import Loading from "oc/components/loading";
import { useOcCurrentUserState } from "oc/hooks";

export const OcHomePageWrapper = () => {
  const history = useHistory();
  const { state: myNewsEnabled } = useMyNewsEnabled();
  const { contractCode } = useOcCurrentUserState();
  const { hasRole, loading: rolesLoading } = useMyHrUserRolesDataByContract({
    contract: contractCode,
  });
  const hasMyNewsUserRole = hasRole(["MyNews.user"], []);
  const { data, loading: listLoading } = useMyNewsList({ archived: false });

  const loading = rolesLoading || listLoading;

  const hasReadAllNews =
    data?.rows?.every((item: { read?: boolean }) => item?.read) ?? false;
  const isHistoryPushOrPop = ["PUSH", "POP"].includes(history.action);

  const navigateToMyInfo =
    !loading &&
    myNewsEnabled &&
    hasMyNewsUserRole &&
    hasReadAllNews &&
    !isHistoryPushOrPop;

  useEffect(() => {
    if (navigateToMyInfo) {
      const hasNavigated = sessionStorage.getItem("navigatedToMyInfo");
      if (!hasNavigated) {
        sessionStorage.setItem("navigatedToMyInfo", "true");
        history.replace("/my-hr/my-info");
      }
    }
  }, [navigateToMyInfo, history]);

  if (loading) {
    return <Loading show />;
  }

  return (
    <div className="oc-home-page-wrapper">
      {myNewsEnabled && hasMyNewsUserRole ? (
        <MyNewsListPage />
      ) : (
        <MyHRMyInfoPage />
      )}
    </div>
  );
};

export default OcHomePageWrapper;
